import { observer } from 'mobx-react-lite'
import React from 'react'

import { CreateTriviaListView } from './create-trivia-list-view'
import { useCreateUserTriviaList } from '../queries/useCreateUserTriviaList'
import { useUserTriviaListImageStorageFolder } from '../queries/useUserTriviaListImageStorageFolder'

export const CreateTriviaListRoute = observer(function CreateTriviaListRoute(): React.ReactElement {
  const { mutateAsync: createTriviaList } = useCreateUserTriviaList()

  const storageFolder = useUserTriviaListImageStorageFolder()

  return (
    <CreateTriviaListView createTriviaList={createTriviaList} imageStorageFolder={storageFolder} />
  )
})
